export default "__VITE_ASSET__gv1eyUfr__"